import { array, boolean, number, object, string, z } from "zod";

import "@/models/lady-dtos";

export const MailListLetter = object({
  direction: string(),
  id: number(),
  isDeletedByLady: boolean(),
  isDeletedByMan: boolean(),
  isFree: boolean(),
  isOpened: boolean(),
  isSent: boolean(),
  ladyId: number(),
  manId: number(),
  partialId: number(),
  sentDate: number().optional(),
  subject: string(),
  value: number(),
  attachFileId1: number().optional(),
});

export const MailListLetterResponseDto_Raw = object({
  count: number(),
  itemArray: array(MailListLetter),
});

export const MailListLetterResponseDto = MailListLetterResponseDto_Raw.extend({
  itemArray: array(MailListLetter),
});

export type MailListLetterResponseDto_Raw = z.infer<
  typeof MailListLetterResponseDto_Raw
>;
export type MailListLetterResponseDto = z.infer<
  typeof MailListLetterResponseDto
>;
